var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"centered"},[_c('h1',{staticStyle:{"font-size":"4em"}},[_vm._v("✌Fight On!")])])])}]

export { render, staticRenderFns }